import {
  SET_SEARCH,
} from './types';

export const INIT_STATE = {
  search: {
    searchType: '',
    terms: '',
    pageSize: -1
  }
};

const mutations = {
  [SET_SEARCH](state, search) {
    state.search = {
      ...state.search,
      ...search
    };
  }
};

export default mutations;
